/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {AnalyticsService} from './@core/utils/analytics.service';
import {PlatformService} from './@core/utils/platform.service';
import {PushNotificationsService} from './@core/utils/push-notifications.service';
import {NavigationFocusService} from './@core/utils/navigation-focus.service';
import {RestaurantTabSyncService} from './@core/utils/restaurant-tab-sync.service';
import {SeoService} from './@core/utils/seo.service';
import {AppPrimeLocaleService} from './@theme/prime/app-prime-locale.service';
import {SeasonalThemeService} from './@theme/season/seasonal-theme.service';
import {hideGlobalSpinner} from './@theme/layouts/layout-shell.utils';
import {AppDrawerHostComponent} from './@theme/prime/app-drawer-host.component';

@Component({
	standalone: false,
	selector: 'ngx-app',
	template: `
		<ngx-season-atmosphere place="loader" />
		<router-outlet></router-outlet>
		<ngx-app-drawer-host />
		<p-toast position="top-right" />
	`,
})
export class AppComponent implements OnInit, AfterViewInit {

	constructor(
		private analytics: AnalyticsService,
		private seoService: SeoService,
		private platformService: PlatformService,
		private pushNotificationsService: PushNotificationsService,
		private restaurantTabSync: RestaurantTabSyncService,
		private navigationFocus: NavigationFocusService,
		private _appPrimeLocale: AppPrimeLocaleService,
		private _seasonalTheme: SeasonalThemeService,
		@Inject(DOCUMENT) private readonly document: Document,
	) {
	}

	ngOnInit(): void {
		this.analytics.trackPageViews();
		this.seoService.trackCanonicalChanges();
		void this.platformService.initNativeShell();
		this.pushNotificationsService.initAfterLogin();
		this.restaurantTabSync.init();
		this.navigationFocus.init();
	}

	ngAfterViewInit(): void {
		// Secours si le layout authentifié ne monte pas (chunk lazy-load, erreur runtime…).
		window.setTimeout(() => hideGlobalSpinner(this.document), 4000);
	}

}
